export default __webpack_public_path__ + "static/media/avatar.59e2f438.jpg";